
import ImgLoader from '@/components/core/img-loader/img-loader.vue';

export default {
  name: 'ImgCta',
  components: { ImgLoader },
  props: {
    image: {
      type: String,
      required: true,
    },
    text: {
      type: String,
      required: true,
    },
    size: {
      type: String,
      default: 'normal',
      validator: (value) => ['normal', 'small'].includes(value),
    },
  },
};
